/* Packwolke — Galerie folgt der Groessenauswahl (2026-08-10)
 *
 * Problem: Auf der PW-Produktseite sind die Groessen-Karten (.pw-vcard) und die
 * Galerie (.pw-thumb / .pw-gallery__main) zwei getrennte Bausteine. Beim Wechsel
 * von S auf M wurden Preis und URL aktualisiert, das Hauptbild blieb aber stehen —
 * der Kunde sah bei jeder Groesse dasselbe Paket.
 *
 * Loesung: Dieses Skript verbindet beide.
 *   1. Beim Groessenwechsel wird das Paketbild der Variante zum Hauptbild.
 *   2. Die Paketbilder der DREI anderen Groessen werden ausgeblendet — in der
 *      Galerie steht nur das Paket, das der Kunde gerade gewaehlt hat, dazu die
 *      allgemeinen Produktbilder.
 *   3. Die Section rendert nur die ersten 6 Medien. Da wir drei davon ausblenden,
 *      wuerde sonst ein echtes Galeriebild dauerhaft wegfallen — fehlende Medien
 *      werden deshalb aus dem Product-JSON nachgetragen.
 *
 * Rein additiv — findet es die Bausteine oder die Variantenbilder nicht, passiert
 * schlicht nichts und die Seite verhaelt sich wie vorher.
 */
(function () {
  function init() {
    var cards = document.querySelectorAll('[data-pw-vcard]');
    var wrap = document.querySelector('.pw-gallery__thumbs');
    var main = document.querySelector('.pw-gallery__main img');
    if (!cards.length || !wrap || !main) return;

    var handle = (window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!handle) return;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* Der Dateiname ohne Query ist der gemeinsame Nenner zwischen dem Variantenbild
       aus dem JSON und der data-src des Thumbs (die Breiten-Parameter unterscheiden sich). */
    function key(url) {
      if (!url) return '';
      return url.split('?')[0].split('/').pop();
    }
    function sized(url, w) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }

    fetch(rootUrl + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !product.variants) return;

        /* Welches Bild gehoert zu welcher Variante — und welche Bilder sind
           ueberhaupt groessenspezifisch (nur die duerfen ausgeblendet werden). */
        var mediaOfVariant = {};
        var isSizeImage = {};
        product.variants.forEach(function (v) {
          if (v.featured_image && v.featured_image.src) {
            var k = key(v.featured_image.src);
            mediaOfVariant[v.id] = k;
            isSizeImage[k] = true;
          }
        });
        /* Keine Variantenbilder gepflegt = nichts zu tun. */
        if (!Object.keys(mediaOfVariant).length) return;

        function thumbs() {
          return Array.prototype.slice.call(wrap.querySelectorAll('[data-pw-thumb]'));
        }

        function activate(t) {
          thumbs().forEach(function (x) { x.classList.remove('active'); });
          t.classList.add('active');
          main.src = t.getAttribute('data-src');
          var img = t.querySelector('img');
          if (img && img.alt) main.alt = img.alt;
        }

        /* Von der Section abgeschnittene Medien nachtragen. */
        var present = {};
        thumbs().forEach(function (t) { present[key(t.getAttribute('data-src'))] = true; });
        (product.media || []).forEach(function (m) {
          if (!m.src) return;
          if (m.media_type && m.media_type !== 'image') return;
          var k = key(m.src);
          if (present[k]) return;
          var t = document.createElement('div');
          t.className = 'pw-thumb';
          t.setAttribute('data-pw-thumb', '');
          t.setAttribute('data-src', sized(m.src, 1600));
          var img = document.createElement('img');
          img.src = sized(m.src, 300);
          img.alt = m.alt || '';
          img.loading = 'lazy';
          img.width = 300;
          img.height = 300;
          t.appendChild(img);
          t.addEventListener('click', function () { activate(t); });
          wrap.appendChild(t);
          present[k] = true;
        });

        function show(variantId) {
          var wanted = mediaOfVariant[variantId];
          var visible = 0;
          var target = null;
          thumbs().forEach(function (t) {
            var k = key(t.getAttribute('data-src'));
            var hide = isSizeImage[k] && k !== wanted;
            t.style.display = hide ? 'none' : '';
            if (!hide) visible++;
            if (k === wanted) target = t;
          });
          /* Spaltenzahl nachziehen, sonst reisst die Thumb-Leiste Luecken. */
          /* Die Thumb-Leiste ist seit 2026-08-18 ein Flex-Layout mit fester Kachelgroesse -
             ein Inline-grid-template-columns hat dort keine Wirkung mehr und wuerde den
             Quadrat-Fix nur wieder gefaehrden, sobald jemand auf Grid zurueckstellt. */
          if (target) activate(target);
        }

        Array.prototype.forEach.call(cards, function (card) {
          card.addEventListener('click', function () { show(card.getAttribute('data-variant-id')); });
          card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') show(card.getAttribute('data-variant-id'));
          });
        });

        /* Direkteinstieg per ?variant=... soll sofort das richtige Paket zeigen. */
        var selected = document.querySelector('[data-pw-vcard].selected');
        var initial = new URLSearchParams(window.location.search).get('variant')
          || (selected && selected.getAttribute('data-variant-id'));
        if (initial) show(initial);
      })
      .catch(function () { /* Netzwerkfehler: Galerie bleibt einfach statisch. */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
